import { useCallback } from 'react';

import { useListConsumerCauses } from '@givebacks/api/backer';
import { useShowCauseW_Selector } from '@givebacks/api/core';
import { ImageMantine, Modal, Skeleton, Stack, Text } from 'ui';

import { ClickableOptionsCard } from '../../../../Cards/ClickableOptionsCard/ClickableOptionsCard';
import { useDirectorySettingsModalProvider } from '../DirectorySettingsModalProvider';

const DirectoryCauseCard = ({ causeId }: { causeId: string }) => {
  const { openModalById, setMeta } = useDirectorySettingsModalProvider({ id: 'base' });
  const { data: cause, isLoading } = useShowCauseW_Selector({ uuid: causeId });

  const handleCauseClick = useCallback(
    (causeId: string) => {
      setMeta({ causeId });
      openModalById('settings');
    },
    [openModalById, setMeta]
  );

  if (!cause) {
    if (isLoading) return <Skeleton visible={isLoading} h={80} />;
    return null;
  }
  return (
    <ClickableOptionsCard.Row
      key={cause.uuid}
      title={cause.name}
      leftSection={<ImageMantine src={cause.logo?.url} radius={12} w={48} h={48} />}
      onClick={() => handleCauseClick(cause.uuid)}
    />
  );
};

const DirectorySettingsModalContent = () => {
  const { openModalById } = useDirectorySettingsModalProvider({});
  const { data } = useListConsumerCauses();

  return (
    <Stack gap="lg">
      <ClickableOptionsCard>
        <ClickableOptionsCard.Row title="Manage Family" onClick={() => openModalById('families')} />
      </ClickableOptionsCard>
      <Stack>
        <Text fz="xs" c="gray">
          Edit visibility settings for each organization.
        </Text>
        <ClickableOptionsCard>
          {data?.causes?.map((cause) => (
            <DirectoryCauseCard key={cause.uuid} causeId={cause.uuid} />
          ))}
        </ClickableOptionsCard>
      </Stack>
    </Stack>
  );
};

const DirectorySettingsModal = () => {
  const { opened, close } = useDirectorySettingsModalProvider({
    id: 'base',
  });
  return (
    <Modal opened={opened} onClose={close} title="Directory Settings">
      <DirectorySettingsModalContent />
    </Modal>
  );
};

export { DirectorySettingsModal };
